// libs
import styled from "styled-components";
// theme
import { typography, colors } from "src/theme";

export const MobileViewMapButton = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 25px;

  z-index: 3500;
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);

  background: ${colors.grey};
  border-radius: 8px;
`;

export const MobileViewMapButtonText = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  color: ${colors.white};
  margin-left: 15px;
`;
